import { autorun, type IReactionDisposer, type IReactionOptions, type IReactionPublic, reaction } from 'mobx';

export class MobxState {
	private reactions: IReactionDisposer[];

	constructor() {
		this.reactions = [];
	}

	autorun(view: (r: IReactionPublic) => void) {
		this.reactions.push(autorun(view));
	}

	reaction<T>(
		expression: (r: IReactionPublic) => T,
		effect: (arg: T, prev: T | undefined, r: IReactionPublic) => void,
		opts?: IReactionOptions<T, boolean>
	) {
		this.reactions.push(reaction(expression, effect, opts));
	}

	/**
	 * Destroy any observers that this class has made.
	 */
	destroy() {
		this.reactions.forEach((r) => r());
	}
}
